import { A } from '../actions/admin';
import update from 'immutability-helper';

const initialState = {
  getDeliveryInfo: {
    isFetching: false,
    error: null,
  },
  getPaymentMethods: {
    isFetching: false,
    error: null,
  },
  getCheckout: {
    isFetching: false,
    error: null,
  },
  getAdminSettings: {
    isFetching: false,
    error: null,
  },
  getWarehouses: {
    isFetching: false,
    error: null,
  },
  getStock: {
    isFetching: false,
    error: null,
  },
  getCompanies: {
    isFetching: false,
    error: null,
  },
  getDocumentHierarchy: {
    isFetching: false,
    error: null,
  },
  getAdminProviders: {
    isFetching: false,
    error: null,
  },
  getMpDtoOrders: {
    isFetching: false,
    error: null,
  },
  getDeliveryServicesAndProducts: {
    isFetching: false,
    error: null,
  },
  getFulfillmentTypes: {
    isFetching: false,
    error: null,
  },
  tokenData: null,
  deliveryInfo: null,
  paymentMethod: null,
  checkout: null,
  settings: null,
  warehouses: null,
  companies: null,
  documentHierarchy: null,
  providers: null,
  mpDtoOrders: null,
  servicesAndProducts: null,
  fulfillmentType: null,
  getEshopTypes: {
    isFetching: false,
    error: null,
  },
  eshopTypes: null,
  getEshopInfoList: {
    isFetching: false,
    error: null,
  },
  eshopInfoList: null,
  getEshopPriceType: {
    isFetching: false,
    error: null,
  },
  eshopPriceType: null,
  getOzonWarehouseList: {
    isFetching: false,
    error: null,
  },
  // ozonWarehouseList: null,
  subtypesFbo: null,
  getSubtypesFbo: {
    isFetching: false,
    error: null,
  },
};

const admin = (state = initialState, action) => {
  switch (action.type) {
    /* Информация о доставке */
    case A.REQUEST_GET_ADMIN_DELIVERY_INFO:
      return update(state, {
        getDeliveryInfo: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_DELIVERY_INFO:
      return update(state, {
        getDeliveryInfo: {
          isFetching: { $set: false },
        },
        deliveryInfo: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_DELIVERY_INFO:
      return update(state, {
        getDeliveryInfo: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Информация о способе оплаты */
    case A.REQUEST_GET_ADMIN_PAYMENT_METHOD:
      return update(state, {
        getPaymentMethods: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_PAYMENT_METHOD:
      return update(state, {
        getPaymentMethods: {
          isFetching: { $set: false },
        },
        paymentMethod: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_PAYMENT_METHOD:
      return update(state, {
        getPaymentMethods: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Чекаут */
    case A.REQUEST_GET_ADMIN_CHECKOUT:
      return update(state, {
        getCheckout: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_CHECKOUT:
      return update(state, {
        getCheckout: {
          isFetching: { $set: false },
        },
        checkout: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_CHECKOUT:
      return update(state, {
        getCheckout: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Настройки lite */
    case A.REQUEST_GET_ADMIN_SETTINGS:
      return update(state, {
        getAdminSettings: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_SETTINGS:
      return update(state, {
        getAdminSettings: {
          isFetching: { $set: false },
        },
        settings: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_SETTINGS:
      return update(state, {
        getAdminSettings: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Настройки складов */
    case A.REQUEST_GET_ADMIN_WAREHOUSE:
      return update(state, {
        getWarehouses: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_WAREHOUSE:
      return update(state, {
        getWarehouses: {
          isFetching: { $set: false },
        },
        warehouses: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_WAREHOUSE:
      return update(state, {
        getWarehouses: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /*Получение списка компаний*/
    case A.REQUEST_GET_ADMIN_COMPANIES:
      return update(state, {
        getCompanies: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_COMPANIES:
      return update(state, {
        getCompanies: {
          isFetching: { $set: false },
        },
        companies: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_COMPANIES:
      return update(state, {
        getCompanies: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /*Получение информации для плашки Иерархия документов*/
    case A.REQUEST_GET_ADMIN_HIERARCHY:
      return update(state, {
        getDocumentHierarchy: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_HIERARCHY:
      return update(state, {
        getDocumentHierarchy: {
          isFetching: { $set: false },
        },
        documentHierarchy: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_HIERARCHY:
      return update(state, {
        getDocumentHierarchy: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /*Заявки на подключение партнерских фулфилмент провайдеров*/
    case A.REQUEST_GET_ADMIN_PROVIDERS:
      return update(state, {
        getAdminProviders: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_PROVIDERS:
      return update(state, {
        getAdminProviders: {
          isFetching: { $set: false },
        },
        providers: { $set: action.data },
      });

    case A.ERROR_GET_ADMIN_PROVIDERS:
      return update(state, {
        getAdminProviders: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Получение списка MP DTO заказов в админ-панели*/
    case A.REQUEST_GET_MP_DTO_ORDERS:
      return update(state, {
        getMpDtoOrders: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_MP_DTO_ORDERS:
      return update(state, {
        getMpDtoOrders: {
          isFetching: { $set: false },
        },
        mpDtoOrders: { $set: action.data },
      });

    case A.ERROR_GET_MP_DTO_ORDERS:
      return update(state, {
        getMpDtoOrders: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Получение  справочника служб доставки и доступных продуктов этих служб в админ-панели*/
    case A.REQUEST_GET_DELIVERY_SERVICE_LIST:
      return update(state, {
        getDeliveryServicesAndProducts: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DELIVERY_SERVICE_LIST:
      return update(state, {
        getDeliveryServicesAndProducts: {
          isFetching: { $set: false },
        },
        servicesAndProducts: { $set: action.data },
      });

    case A.ERROR_GET_DELIVERY_SERVICE_LIST:
      return update(state, {
        getDeliveryServicesAndProducts: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    /* Получение списка возможных значений fulfillmentType и их зависимых fulfillmentSubType и русской транскрипции*/

    case A.REQUEST_GET_FULFILLMENT_TYPES:
      return update(state, {
        getFulfillmentTypes: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_FULFILLMENT_TYPES:
      return update(state, {
        getFulfillmentTypes: {
          isFetching: { $set: false },
        },
        fulfillmentType: { $set: action.data },
      });

    case A.ERROR_GET_FULFILLMENT_TYPES:
      return update(state, {
        getFulfillmentTypes: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    //Получение типов маркетплейсов
    case A.REQUEST_GET_ESHOP_TYPES:
      return update(state, {
        getEshopTypes: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ESHOP_TYPES:
      return update(state, {
        getEshopTypes: {
          isFetching: { $set: false },
        },
        eshopTypes: { $set: action.data },
      });

    case A.ERROR_GET_ESHOP_TYPES:
      return update(state, {
        getEshopTypes: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ESHOP_INFO_LIST:
      return update(state, {
        getEshopInfoList: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ESHOP_INFO_LIST:
      return update(state, {
        getEshopInfoList: {
          isFetching: { $set: false },
        },
        eshopInfoList: { $set: action.data },
      });

    case A.ERROR_GET_ESHOP_INFO_LIST:
      return update(state, {
        getEshopInfoList: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ESHOP_PRICE_TYPE:
      return update(state, {
        getEshopPriceType: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ESHOP_PRICE_TYPE:
      return update(state, {
        getEshopPriceType: {
          isFetching: { $set: false },
        },
        eshopPriceType: { $set: action.data },
      });

    case A.ERROR_GET_ESHOP_PRICE_TYPE:
      return update(state, {
        getEshopPriceType: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ESHOP_OZON_WAREHOUSE_LIST:
      return update(state, {
        getOzonWarehouseList: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ESHOP_OZON_WAREHOUSE_LIST:
      return update(state, {
        getOzonWarehouseList: {
          isFetching: { $set: false },
        },
        // ozonWarehouseList: { $set: action.data },
      });

    case A.ERROR_GET_ESHOP_OZON_WAREHOUSE_LIST:
      return update(state, {
        getOzonWarehouseList: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    //Типы

    case A.REQUEST_GET_ADMIN_SUBTYPES_FBO:
      return update(state, {
        getSubtypesFbo: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADMIN_SUBTYPES_FBO:
      return update(state, {
        getSubtypesFbo: {
          isFetching: { $set: false },
        },
        subtypesFbo: { $set: action.data },
      });
    case A.ERROR_GET_ADMIN_SUBTYPES_FBO:
      return update(state, {
        getSubtypesFbo: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default admin;
